// import { useState, useEffect, useRef } from "react";
// import { useSearchParams, useNavigate, useLocation } from "react-router-dom";
// import App from "../App";
import OnboardingScreen from "../components/OnboardingScreen";
// import { loadMusicFromDocProfile } from "../utils/musicExport";
// import { reportApiError } from "../utils/errorPopupBridge";
// import type { GenerateMusicResult } from "../utils/generateMusic";

// type MusicEditorLocationState = {
//   initialMusicResult?: GenerateMusicResult;
//   initialPrompt?: string;
//   initialSelections?: Record<string, string[]>;
// };

export default function MusicEditorPage() {
  // const [searchParams] = useSearchParams();
  // const navigate = useNavigate();
  // const location = useLocation();
  // const locationState = location.state as MusicEditorLocationState | null;
  // const isOnboarding = searchParams.get("onboarding") === "true";
  const isOnboarding = true;
  // const [initialPrompt, setInitialPrompt] = useState<string | undefined>(
  //   locationState?.initialPrompt,
  // );
  // const [initialSelections, setInitialSelections] = useState<
  //   Record<string, string[]> | undefined
  // >(locationState?.initialSelections);
  // const [initialMusicResult, setInitialMusicResult] = useState<
  //   GenerateMusicResult | undefined
  // >(locationState?.initialMusicResult);
  // const [isLoadingFromBlob, setIsLoadingFromBlob] = useState(false);
  // const hasLoaded = useRef(false);
  // const docId = searchParams.get("docId");

  // useEffect(() => {
  //   if (!locationState?.initialMusicResult) return;
  //   setInitialMusicResult(locationState.initialMusicResult);
  //   setInitialPrompt(locationState.initialPrompt);
  //   setInitialSelections(locationState.initialSelections);
  //   navigate(location.pathname, { replace: true, state: null });
  // }, [location.pathname, locationState, navigate]);

  // useEffect(() => {
  //   if (!docId) return;
  //   async function loadBlobMusic() {
  //     if (hasLoaded.current) return;
  //     hasLoaded.current = true;
  //     setIsLoadingFromBlob(true);
  //     try {
  //       const result = await loadMusicFromDocProfile(docId!);
  //       setInitialMusicResult(result);
  //     } catch (error) {
  //       console.error("Failed to load music from blob:", error);
  //       reportApiError(error);
  //     } finally {
  //       setIsLoadingFromBlob(false);
  //     }
  //   }
  //   loadBlobMusic();
  // }, [docId]);

  if (isOnboarding) {
    return <OnboardingScreen />;
  }

  // TODO: re-enable music editor redirect when ready
  // return (
  //   <App
  //     initialMusicResult={initialMusicResult}
  //     initialPrompt={initialPrompt}
  //     initialSelections={initialSelections}
  //     isLoadingFromBlob={isLoadingFromBlob}
  //   />
  // );

  return <OnboardingScreen />;
}
